/* SLIDE 32 */
/* SLIDE 33 */

import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setSelectedSpots, fetchAllParkingSpots, fetchAllParkingSpotTypes } from "features/parking/presentation/store/parkingSlice";
import SubHeader from "shared/components/SubHeader";

const PakingAttendancePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {

    dispatch(fetchAllParkingSpots());
    dispatch(fetchAllParkingSpotTypes());

  }, [dispatch]);
  const today = new Date();
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());

  const months = Array.from({ length: 12 }, (_, i) => i + 1);

  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const getDaysInPreviousMonth = (year, month) => {
    const prevMonth = month === 0 ? 11 : month - 1;
    const prevYear = month === 0 ? year - 1 : year;
    return getDaysInMonth(prevYear, prevMonth);
  };

  const getStartDay = (year, month) => {
    return new Date(year, month, 1).getDay();
  };

  const daysInMonth = getDaysInMonth(currentYear, currentMonth);
  const startDay = getStartDay(currentYear, currentMonth);
  const prevMonthDays = getDaysInPreviousMonth(currentYear, currentMonth);

  const days = [];

  for (let i = startDay - 1; i >= 0; i--) {
    days.push({
      day: prevMonthDays - i,
      currentMonth: false,
    });
  }

  for (let i = 1; i <= daysInMonth; i++) {
    days.push({
      day: i,
      currentMonth: true,
    });
  }

  let nextMonthDay = 1;
  while (days.length < 42) {
    days.push({
      day: nextMonthDay++,
      currentMonth: false,
    });
  }

  const [selectedOption, setSelectedOption] = useState("사용자정보(01-002)");

  const options = [
    "사용자정보(01-002)",
    "사용자정보(01-001)",
    "사용자정보(01-003)",
  ];
  const handleChange = (e) => {
    setSelectedOption(e.target.value);
  };
  return (
    <div className={`parking-status-container parking-attendance-container`}>
      <SubHeader >
        <div className={`sub-header-text w-full`} >

          <span className="htColorGray2">주차장명 : </span>
          <span className="htBold">새마을시장(01-002)</span>

        </div>
      </SubHeader>
      <div className="htContent">
        <div className="mn-header-attendance">
          <div className="mn-calendar-header table-header">
            <select
              className="table-select"
              value={currentYear}
              onChange={(e) => setCurrentYear(Number(e.target.value))}
            >
              {Array.from({ length: 5 }, (_, i) => today.getFullYear() - 2 + i).map((year) => (
                <option key={year} value={year}>{year}</option>
              ))}
            </select>
            <select
              className="table-select"
              value={currentMonth + 1}
              onChange={(e) => setCurrentMonth(Number(e.target.value) - 1)}
            >
              {months.map((month) => (
                <option key={month} value={month}>{month}</option>
              ))}
            </select>
          </div>
        </div>
        <table className="mn-calendar-table mn-attendance-table mt-10">
          <thead>
            <tr>
              {["일", "월", "화", "수", "목", "금", "토"].map((day) => (
                <th key={day}>{day}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {Array.from({ length: 6 }).map((_, weekIndex) => (
              <tr key={weekIndex}>
                {Array.from({ length: 7 }).map((_, dayIndex) => {
                  const day = days[weekIndex * 7 + dayIndex];
                  return (
                    <td
                      onClick={() => navigate("/parking_detail_attendance")}
                      key={dayIndex}
                      className={`day && !day.currentMonth ? "prev-next-month" : "" ${day?.currentMonth && day.day === 19 ? "bg-date-red" : ""} ${day?.currentMonth && day.day === 21 ? "bg-date-blue" : ""}`}
                    >
                      {day && (
                        <div className="day-number">
                          {day.day}
                        </div>
                      )}
                      {day && (
                        <>
                          {((day.currentMonth && (day.day === 5 || day.day === 12 || day.day === 11 || day.day === 18)) ||
                            (!day.currentMonth && (day.day === 28 || day.day === 29))) && (
                              <div className="event-bar green1">8시간 3분</div>
                            )}

                          {((day.currentMonth && (day.day === 4 || day.day === 6 || day.day === 7 || day.day === 13 || day.day === 14 || day.day === 20 || day.day === 21)) ||
                            (!day.currentMonth && (day.day === 30 || day.day === 31))) && (
                              <div className="event-bar green1">8시간</div>
                            )}
                          {day.currentMonth && day.day === 19 && (
                            <div className="event-bar red">4시간</div>
                          )}
                        </>
                      )}


                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="calendar-footer mn-attendance-footer">
          총 근무시간 <span style={{fontSize:"15px"}}>04시간 21분</span>
      </div>

    </div>
  );
};

export default PakingAttendancePage;
